import React from 'react'

const GraphQLIcon = () => (
  <svg width="121" height="135" viewBox="0 0 121 135" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.99143 100.03L10.9473 102.891L66.1573 7.26709L61.2015 4.40575L5.99143 100.03Z" fill="#E535AB" />
    <path d="M115.278 92.3904H4.85742V98.113H115.278V92.3904Z" fill="#E535AB" />
    <path d="M7.04271 95.6052L62.2734 127.494L65.1348 122.538L9.90404 90.6494L7.04271 95.6052Z" fill="#E535AB" />
    <path d="M55.0212 12.4956L110.252 44.384L113.113 39.4282L57.8826 7.53978L55.0212 12.4956Z" fill="#E535AB" />
    <path d="M7.05663 39.4062L9.91797 44.3621L65.1487 12.4736L62.2874 7.51781L7.05663 39.4062Z" fill="#E535AB" />
    <path d="M54.0243 7.26806L109.234 102.892L114.19 100.031L58.9802 4.40672L54.0243 7.26806Z" fill="#E535AB" />
    <path d="M14.9571 35.6116H9.23438V99.3884H14.9571V35.6116Z" fill="#E535AB" />
    <path d="M110.934 35.6116H105.211V99.3884H110.934V35.6116Z" fill="#E535AB" />
    <path d="M58.7995 120.742L61.2988 125.071L109.335 97.337L106.835 93.0081L58.7995 120.742Z" fill="#E535AB" />
    <path
      d="M118.516 101.25C115.206 107.007 107.829 108.972 102.072 105.663C96.3148 102.353 94.3497 94.9758 97.6592 89.2186C100.969 83.4615 108.346 81.4965 114.103 84.806C119.895 88.1499 121.86 95.4929 118.516 101.25Z"
      fill="#E535AB"
    />
    <path
      d="M22.473 45.7813C19.1635 51.5385 11.7861 53.5035 6.02894 50.194C0.271791 46.8845 -1.69322 39.507 1.61628 33.7499C4.92578 27.9927 12.3032 26.0277 18.0604 29.3372C23.8175 32.6812 25.7825 40.0241 22.473 45.7813Z"
      fill="#E535AB"
    />
    <path
      d="M1.65143 101.25C-1.65807 95.4929 0.306946 88.1499 6.0641 84.806C11.8212 81.4965 19.1642 83.4615 22.5082 89.2186C25.8177 94.9758 23.8527 102.319 18.0955 105.663C12.3039 108.972 4.96093 107.007 1.65143 101.25Z"
      fill="#E535AB"
    />
    <path
      d="M97.6944 45.7813C94.3849 40.0241 96.3499 32.6812 102.107 29.3372C107.864 26.0277 115.207 27.9927 118.551 33.7499C121.861 39.507 119.896 46.85 114.138 50.194C108.381 53.5035 101.004 51.5385 97.6944 45.7813Z"
      fill="#E535AB"
    />
    <path
      d="M60.0841 135C53.4307 135 48.0527 129.622 48.0527 122.969C48.0527 116.315 53.4307 110.937 60.0841 110.937C66.7376 110.937 72.1156 116.315 72.1156 122.969C72.1156 129.588 66.7376 135 60.0841 135Z"
      fill="#E535AB"
    />
    <path
      d="M60.0841 24.0628C53.4307 24.0628 48.0527 18.6849 48.0527 12.0314C48.0527 5.37794 53.4307 0 60.0841 0C66.7376 0 72.1156 5.37794 72.1156 12.0314C72.1156 18.6849 66.7376 24.0628 60.0841 24.0628Z"
      fill="#E535AB"
    />
  </svg>
)

export default GraphQLIcon
